import React, { useEffect } from "react";
import { getIn } from "formik";
import { Button } from "@shopify/polaris";
import { composeGid } from "@shopify/admin-graphql-api-utilities";
import {
  addInventoryItems,
  addInventoryItemsForVariants
} from "lib/formHelpers";

function selectionIdsFromSelection(selection, target, showVariants) {
  if (target === "Product" && showVariants) {
    return selection.map(product => ({
      id: product.id,
      variants: product.variants.map(variant => ({ id: variant.id }))
    }));
  }

  return selection.map(item => ({ id: item.id }));
}

function selectionIdsFromIds(ids, target) {
  return ids.map(id => ({ id: composeGid(target, id) }));
}

function selectionIdsFromProductVariants(productVariants = []) {
  return productVariants.map(product => ({
    id: composeGid("Product", product.product_id),
    variants: product.variants.map(variant => ({
      id: composeGid("ProductVariant", variant.id)
    }))
  }));
}

export default function PolarisFormikInventoryPickerButton({
  allowMultiple = true,
  form,
  handlesFieldName,
  idsFieldName,
  selectionIds,
  setSelectionIds,
  showVariants = false,
  target,
  title,
  titlesFieldName,
  variantsFieldName
}) {
  useEffect(() => {
    if (idsFieldName) {
      const ids = getIn(form.values, idsFieldName);
      const initialSelectionIds = selectionIdsFromIds(ids, target);

      setSelectionIds(initialSelectionIds);
      return;
    }

    if (variantsFieldName) {
      const productVariants = getIn(form.values, variantsFieldName);
      const initialSelectionIds =
        selectionIdsFromProductVariants(productVariants);

      setSelectionIds(initialSelectionIds);
      return;
    }
  }, []);

  const togglePicker = async () => {
    try {
      const selection = await shopify.resourcePicker({
        type: target.toLowerCase(), // "product", "variant", or "collection"
        multiple: allowMultiple,
        // Whether to show product variants. Only applies to the Product resource type picker.
        filter: target === "Product" ? { variants: showVariants } : undefined,
        selectionIds: selectionIds
      });
      if (selection && selection.length > 0) {
        const items = { selection };
        const newSelectionIds = selectionIdsFromSelection(
          items.selection,
          target,
          showVariants
        );

        if (!!idsFieldName && !!titlesFieldName && !!handlesFieldName) {
          addInventoryItems(
            form,
            idsFieldName,
            titlesFieldName,
            handlesFieldName,
            items
          );
        }

        if (target === "Product" && showVariants && !!variantsFieldName) {
          addInventoryItemsForVariants(form, variantsFieldName, items);
        }

        setSelectionIds(newSelectionIds);
      }
    } catch (error) {
      // User cancelled the picker
    }
  };

  return (
    <div className="InventoryPicker-Button">
      <Button onClick={togglePicker}>{title}</Button>
    </div>
  );
}
